/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
(function() {
    // Variables globales para el hover
    window.paisanaHoverPlace = function(element) {
        const imageUrl = element.getAttribute('data-image-url');
        const imageAlt = element.getAttribute('data-image-alt');
        const mainImage = document.getElementById('paisana-main-image');
        
        if (mainImage && imageUrl) {
            mainImage.src = imageUrl;
            mainImage.alt = imageAlt;
        }
    };
    
    window.paisanaResetPlace = function() {
        const mainImage = document.getElementById('paisana-main-image');
        if (mainImage) {
            const defaultImage = mainImage.getAttribute('data-default-image');
            const defaultAlt = mainImage.getAttribute('data-default-alt');
            
            if (defaultImage) {
                mainImage.src = defaultImage;
                mainImage.alt = defaultAlt;
            }
        }
    };
    
    // Inicialización
    document.addEventListener('DOMContentLoaded', function() {
        // Opcional: añadir clase activa al primer elemento
        const firstItem = document.querySelector('[data-place-id]');
        if (firstItem) {
            firstItem.classList.add('is-active');
        }
    });
})();
/* eslint-enable no-console */
